import _ from "lodash";
import {
  APP_INSIGHTS_EVENTS,
  INVENTORY_ADJUSTMENTS_TRESHHOLD,
  SAG_THROUGHPUT_VALUE,
} from "../constants";

import { piDataType } from "../queries/types";

export type createHighchartOptions = {
  data: piDataType[];
  plotBands: any;
  name: string;
  pointClick(e: any): void;
  trackEvent(name: string, data: any): void;
  dataId: string;
  sensor: string;
};

const createHighchartOptions = ({
  data,
  name = "filename",
  pointClick,
  trackEvent,
  plotBands = [],
  dataId,
  sensor,
}: createHighchartOptions) => {
  const dryTonnes = sensor === SAG_THROUGHPUT_VALUE;
  const series = JSON.parse(JSON.stringify(data));
  return {
    title: {
      text: "",
    },
    chart: {
      type: "line",
      backgroundColor: "#FAFAFA",
      zoomType: "xy",
      style: {
        fontFamily: "Helvetica",
      },
      events: {
        selection: function () {
          if (trackEvent)
            trackEvent(APP_INSIGHTS_EVENTS.CHANGE_GRAPH_ZOOM, {
              graph: dataId,
            });
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const date = new Date(this.x);
        let tooltip = `<div><span>Day: ${date.getUTCDate()}, hour: ${date
          .toUTCString()
          .match(/\d\d:\d\d/)}</span></br>`;

        if (this.point) {
          tooltip += `<b><span style="color: ${this.point.color};">${
            this.point.series.name
          }</span>: <span>${Number(this.point.y).toFixed(3)}</span></b></br>`;
          tooltip += `<span><b>Title</b></span>: <span>${this.point.title}</span></br>`;
          tooltip += `<span><b>Text</b></span>: <span>${this.point.text}</span></br>`;
        }

        if (this.points) {
          this.points
            .filter((item) => item.y)
            .forEach((item) => {
              tooltip += `<b><span style="color: ${item.color};">${
                item.series.name
              }</span>: <span>${Number(item.y).toFixed(3)}</span></b>${
                dryTonnes && item.y > INVENTORY_ADJUSTMENTS_TRESHHOLD
                  ? "<span> (inventory adjustment)</span>"
                  : ""
              }</br>
              `;
            });
          tooltip += "</div>";
        }

        return tooltip;
      },
      valueDecimals: 3,
    },
    exporting: {
      filename: name,
    },
    plotOptions: {
      series: {
        cursor: "pointer",
        point: {
          events: {
            click: (e) => pointClick(e),
            mouseOver: function () {
              trackEvent(APP_INSIGHTS_EVENTS.POINT_GRAPH_ITEM, {
                graph: dataId,
              });
            },
          },
        },
      },
    },
    yAxis: {
      type: "linear",
      scrollbar: {
        enabled: true,
      },
      labels: {
        style: {
          color: "black",
        },
      },
      title: {
        text: "",
        style: {
          color: "black",
        },
      },
      minPadding: 0.15,
      maxPadding: 0.15,
    },
    xAxis: {
      type: "datetime",
      scrollbar: {
        enabled: true,
      },
      labels: {
        style: {
          color: "black",
        },
        format: "{value:D:%d, h:%H}",
      },
      plotBands,
      gridLineWidth: 1,
    },
    series,
  };
};

export default createHighchartOptions;
